import type {SearchLegalDocumentsRequest} from '@getmoss/api-gateway'
import {locales} from 'src/common/constants'

/**
 * Translations for the LegalDocuments slice
 */
export const TRANSLATIONS = {
  LOADING_DOCUMENTS: {
    [locales['en-us']]: 'Loading documents...',
    [locales['en-gb']]: 'Loading documents...',
    [locales['en-nl']]: 'Loading documents...',
    [locales['en-de']]: 'Loading documents...',
    [locales['de-de']]: 'Dokumente werden geladen...',
    [locales['nl-nl']]: 'Documenten laden...',
    [locales['de-at']]: 'Dokumente werden geladen...',
  },
  NO_DOCUMENTS_FOUND: {
    [locales['en-us']]: 'No documents found for the selected filters.',
    [locales['en-gb']]: 'No documents found for the selected filters.',
    [locales['en-nl']]: 'No documents found for the selected filters.',
    [locales['en-de']]: 'No documents found for the selected filters.',
    [locales['de-de']]: 'Keine Dokumente für die ausgewählten Filter gefunden.',
    [locales['nl-nl']]: 'Geen documenten gevonden voor de geselecteerde filters.',
    [locales['de-at']]: 'Keine Dokumente für die ausgewählten Filter gefunden.',
  },
  ALL_PRODUCTS: {
    [locales['en-us']]: 'All products',
    [locales['en-gb']]: 'All products',
    [locales['en-nl']]: 'All products',
    [locales['en-de']]: 'All products',
    [locales['de-de']]: 'Alle Produkte',
    [locales['nl-nl']]: 'Alle producten',
    [locales['de-at']]: 'Alle Produkte',
  },
  ALL_DOCUMENT_TYPES: {
    [locales['en-us']]: 'All document types',
    [locales['en-gb']]: 'All document types',
    [locales['en-nl']]: 'All document types',
    [locales['en-de']]: 'All document types',
    [locales['de-de']]: 'Alle Dokumenttypen',
    [locales['nl-nl']]: 'Alle documenttypen',
    [locales['de-at']]: 'Alle Dokumenttypen',
  },
  ALL_MARKETS: {
    [locales['en-us']]: 'All markets',
    [locales['en-gb']]: 'All markets',
    [locales['en-nl']]: 'All markets',
    [locales['en-de']]: 'All markets',
    [locales['de-de']]: 'Alle Märkte',
    [locales['nl-nl']]: 'Alle markten',
    [locales['de-at']]: 'Alle Märkte',
  },
  PLATFORM: {
    [locales['en-us']]: 'Moss Platform',
    [locales['en-gb']]: 'Moss Platform',
    [locales['en-nl']]: 'Moss Platform',
    [locales['en-de']]: 'Moss Platform',
    [locales['de-de']]: 'Moss Plattform',
    [locales['nl-nl']]: 'Moss Platform',
    [locales['de-at']]: 'Moss Plattform',
  },
  CREDIT: {
    [locales['en-us']]: 'Moss Credit',
    [locales['en-gb']]: 'Moss Credit',
    [locales['en-nl']]: 'Moss Credit',
    [locales['en-de']]: 'Moss Credit',
    [locales['de-de']]: 'Moss Kredit',
    [locales['nl-nl']]: 'Moss Krediet',
    [locales['de-at']]: 'Moss Kredit',
  },
  CARDS: {
    [locales['en-us']]: 'Moss Cards',
    [locales['en-gb']]: 'Moss Cards',
    [locales['en-nl']]: 'Moss Cards',
    [locales['en-de']]: 'Moss Cards',
    [locales['de-de']]: 'Moss Karten',
    [locales['nl-nl']]: 'Moss Kaarten',
    [locales['de-at']]: 'Moss Karten',
  },
  WALLET: {
    [locales['en-us']]: 'Moss Wallet',
    [locales['en-gb']]: 'Moss Wallet',
    [locales['en-nl']]: 'Moss Wallet',
    [locales['en-de']]: 'Moss Wallet',
    [locales['de-de']]: 'Moss Wallet',
    [locales['nl-nl']]: 'Moss Wallet',
    [locales['de-at']]: 'Moss Wallet',
  },
  PAY_WITH_MOSS: {
    [locales['en-us']]: 'Pay with Moss',
    [locales['en-gb']]: 'Pay with Moss',
    [locales['en-nl']]: 'Pay with Moss',
    [locales['en-de']]: 'Pay with Moss',
    [locales['de-de']]: 'Mit Moss bezahlen',
    [locales['nl-nl']]: 'Betalen met Moss',
    [locales['de-at']]: 'Mit Moss bezahlen',
  },
  GERMANY: {
    [locales['en-us']]: 'Germany',
    [locales['en-gb']]: 'Germany',
    [locales['en-nl']]: 'Germany',
    [locales['en-de']]: 'Germany',
    [locales['de-de']]: 'Deutschland',
    [locales['nl-nl']]: 'Duitsland',
    [locales['de-at']]: 'Deutschland',
  },
  UNITED_KINGDOM: {
    [locales['en-us']]: 'United Kingdom',
    [locales['en-gb']]: 'United Kingdom',
    [locales['en-nl']]: 'United Kingdom',
    [locales['en-de']]: 'United Kingdom',
    [locales['de-de']]: 'Vereinigtes Königreich',
    [locales['nl-nl']]: 'Verenigd Koninkrijk',
    [locales['de-at']]: 'Vereinigtes Königreich',
  },
  NETHERLANDS: {
    [locales['en-us']]: 'Netherlands',
    [locales['en-gb']]: 'Netherlands',
    [locales['en-nl']]: 'Netherlands',
    [locales['en-de']]: 'Netherlands',
    [locales['de-de']]: 'Niederlande',
    [locales['nl-nl']]: 'Nederland',
    [locales['de-at']]: 'Niederlande',
  },
  OTHER_EEA_COUNTRIES: {
    [locales['en-us']]: 'Other EEA countries',
    [locales['en-gb']]: 'Other EEA countries',
    [locales['en-nl']]: 'Other EEA countries',
    [locales['en-de']]: 'Other EEA countries',
    [locales['de-de']]: 'Andere EWR-Länder',
    [locales['nl-nl']]: 'Andere EER-landen',
    [locales['de-at']]: 'Andere EWR-Länder',
  },
  DOWNLOAD_DOCUMENT_IN: {
    [locales['en-us']]: 'Download this document in:',
    [locales['en-gb']]: 'Download this document in:',
    [locales['en-nl']]: 'Download this document in:',
    [locales['en-de']]: 'Download this document in:',
    [locales['de-de']]: 'Dokument herunterladen in:',
    [locales['nl-nl']]: 'Download dit document in:',
    [locales['de-at']]: 'Dokument herunterladen in:',
  },
  DOCUMENT: {
    [locales['en-us']]: 'DOCUMENT',
    [locales['en-gb']]: 'DOCUMENT',
    [locales['en-nl']]: 'DOCUMENT',
    [locales['en-de']]: 'DOCUMENT',
    [locales['de-de']]: 'DOKUMENT',
    [locales['nl-nl']]: 'DOCUMENT',
    [locales['de-at']]: 'DOKUMENT',
  },
  TNC: {
    [locales['en-us']]: 'Terms & Conditions',
    [locales['en-gb']]: 'Terms & Conditions',
    [locales['en-nl']]: 'Terms & Conditions',
    [locales['en-de']]: 'Terms & Conditions',
    [locales['de-de']]: 'Allgemeine Geschäftsbedingungen',
    [locales['nl-nl']]: 'Algemene voorwaarden',
    [locales['de-at']]: 'Allgemeine Geschäftsbedingungen',
  },
  PRIVACY_POLICY: {
    [locales['en-us']]: 'Privacy Policy',
    [locales['en-gb']]: 'Privacy Policy',
    [locales['en-nl']]: 'Privacy Policy',
    [locales['en-de']]: 'Privacy Policy',
    [locales['de-de']]: 'Datenschutzerklärung',
    [locales['nl-nl']]: 'Privacybeleid',
    [locales['de-at']]: 'Datenschutzerklärung',
  },
  DATA_PROCESSING_AGREEMENT: {
    [locales['en-us']]: 'Data Processing Agreement',
    [locales['en-gb']]: 'Data Processing Agreement',
    [locales['en-nl']]: 'Data Processing Agreement',
    [locales['en-de']]: 'Data Processing Agreement',
    [locales['de-de']]: 'Auftragsverarbeitungsvertrag',
    [locales['nl-nl']]: 'Gegevensverwerkingsovereenkomst',
    [locales['de-at']]: 'Auftragsverarbeitungsvertrag',
  },
  FEE_SCHEDULE: {
    [locales['en-us']]: 'Fee Schedule',
    [locales['en-gb']]: 'Fee Schedule',
    [locales['en-nl']]: 'Fee Schedule',
    [locales['en-de']]: 'Fee Schedule',
    [locales['de-de']]: 'Gebührenplan',
    [locales['nl-nl']]: 'Tariefoverzicht',
    [locales['de-at']]: 'Gebührenplan',
  },
} as const

/**
 * Language labels for document downloads
 */
export const LANGUAGE_LABELS = {
  en: {
    [locales['en-us']]: 'English',
    [locales['en-gb']]: 'English',
    [locales['en-nl']]: 'English',
    [locales['en-de']]: 'English',
    [locales['de-de']]: 'Englisch',
    [locales['nl-nl']]: 'Engels',
    [locales['de-at']]: 'Englisch',
  },
  de: {
    [locales['en-us']]: 'German',
    [locales['en-gb']]: 'German',
    [locales['en-nl']]: 'German',
    [locales['en-de']]: 'German',
    [locales['de-de']]: 'Deutsch',
    [locales['nl-nl']]: 'Duits',
    [locales['de-at']]: 'Deutsch',
  },
  nl: {
    [locales['en-us']]: 'Dutch',
    [locales['en-gb']]: 'Dutch',
    [locales['en-nl']]: 'Dutch',
    [locales['en-de']]: 'Dutch',
    [locales['de-de']]: 'Niederländisch',
    [locales['nl-nl']]: 'Nederlands',
    [locales['de-at']]: 'Niederländisch',
  },
} as const

type ExtractArrayType<T> = T extends (infer U)[] ? U : never

/**
 * Product filter option type
 */
export type ProductFilterValue = ExtractArrayType<SearchLegalDocumentsRequest['products']>

/**
 * Market filter option type
 */
export type MarketFilterValue = ExtractArrayType<SearchLegalDocumentsRequest['markets']>

/**
 * Document type filter option type
 */
export type DocumentTypeFilterValue = ExtractArrayType<SearchLegalDocumentsRequest['documentTypes']>

/**
 * Filter option interface
 */
export interface FilterOption<T> {
  category_name: string
  value: T
}
